<template>
	<nav class="c-main-nav" v-if="localizedMainNav" v-bind:class="{ visible: mobileNavVisible }">
		<div class="c-main-nav__bg" v-bind:style="{ transform: 'skew(0, ' + skewRadius + 'deg)' }"></div>

		<div class="container">

			<button class="c-main-nav__burger" @click="toggleMobileNav"><span>Navigation</span></button>

			<router-link
				class="c-main-nav__logo"
				:to="localizedLogoLink">
				<img src="/static/images/bandara-logo.svg" alt="Bandara">
			</router-link>

			<ul class="c-main-nav__list">
				<router-link
					class="c-main-nav__list-item"
					tag="li"
					v-for="item in localizedMainNav.items"
					:key="item.link"
					:to="item.link">
					<a class="c-main-nav__link">
						{{ item.title }}
					</a>
				</router-link>
			</ul>

			<ul class="c-main-nav__lang">
				<li :class="this.settings.currentLang === 'de-ch' ? 'c-main-nav__lang-item is-active' : 'c-main-nav__lang-item'">
					<router-link :to="this.settings.altLangLinks['de-ch']" class="c-main-nav__lang-link" @click.native="handleClick('de-ch')">
						De
					</router-link>
				</li>
				<li :class="this.settings.currentLang === 'en-us' ? 'c-main-nav__lang-item is-active' : 'c-main-nav__lang-item'">
					<router-link :to="this.settings.altLangLinks['en-us']" class="c-main-nav__lang-link" @click.native="handleClick('en-us')">
						En
					</router-link>
				</li>
			</ul>

		</div>
	</nav>
</template>

<script>
export default {
	name: 'main-nav',
	data: () => ({
		mobileNavVisible: false,
		skewRadius: -.7,
		logo: {
			links: {
				'de-ch': '/',
				'en-us': '/en'
			}
		},
		mainNav: {
			'de-ch': {
				items: [
					{
						link: '/service',
						title: 'Angebot'
					},
					{
						link: '/work',
						title: 'Arbeiten'
					},
					{
						link: '/about',
						title: 'Über uns'
					},
					{
						link: '/blog',
						title: 'Blog'
					},
					{
						link: '/contact',
						title: 'Kontakt'
					}
				]
			},
			'en-us': {
				items: [
					{
						link: '/en/service',
						title: 'Service'
					},
					{
						link: '/en/work',
						title: 'Work'
					},
					{
						link: '/en/about',
						title: 'About us'
					},
					{
						link: '/en/contact',
						title: 'Contact'
					}
				]
			}
		}
	}),
	computed: {
		currentRoute() {
			return this.$store.state.route;
		},
		settings() {
			return this.$store.state.general.settings;
		},
		localizedMainNav() {
			return this.mainNav[this.settings.currentLang];
		},
		localizedLogoLink() {
			return this.logo.links[this.settings.currentLang];
		}
	},
	watch: {
		'$route': function() {
			this.mobileNavVisible = false;
			this.setRandomSkewRadius();
		}
	},
	methods: {
		handleClick(lang) {
			this.$store.dispatch('setCurrentLanguage', lang);
		},
		setRandomSkewRadius() {
			this.skewRadius = Math.random() * -2;
		},
		toggleMobileNav() {
			this.mobileNavVisible = !this.mobileNavVisible;
		}
	}
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.c-main-nav {
		background-color: $colorBrandMain;
		padding-top: 2.5rem;
		padding-bottom: 2rem;
		color: #fff;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 99;
		width: 100%;
		font-weight: 600;
		// overflow: hidden;
		transition: .2s background-color;

		@include mq($to: medium) {
			padding: 0;
			position: fixed;
			// min-height: 3.5rem;
			height: auto;
		}

		a {
			text-decoration: none;

			&:hover {
				color: inherit;
				text-decoration: none;
			}
		}

		&__logo {
			position: absolute;
			top: 50%;
			left: .25rem;
			width: 3.5rem;
			height: 3.5rem;
			margin-top: -1.75rem;
			border-radius: 99%;
			box-shadow: 0 2px 0 0 rgba(#000, .1);
			transition: .5s box-shadow $easeOutQuint, .5s transform $easeOutQuint;

			img {
				width: 100%;
				height: 100%;
			}

			@include mq($to: big) {
				left: 2rem;
			}

			@include mq($to: medium) {
				margin: 0;
				left: 1rem;
				top: .5rem;
				width: 3rem;
				height: 3rem;
			}

			&:hover {
				box-shadow: 0 8px 15px 0 rgba(#000, .1);
				transform: translateY(-2px);
			}
		}

		&__link, &__link:visited {
			color: inherit;
			position: relative;

			&::after {
				content: "";
				display: block;
				width: 106%;
				height: 2px;
				background-color: #fff;
				position: absolute;
				bottom: -4px;
				left: -3%;
				transform: scale(0, 1);
				transform-origin: 100% 0;
				transition: .3s transform $easeOutQuint;
			}

			.is-active & {
				color: inherit;

				&::after {
					transform: scale(1, 1);
					transform-origin: 0 0;
				}
			}
			.has-hover & {
				&:hover {
					color: inherit;

					&::after {
						transform: scale(1, 1);
						transform-origin: 0 0;
					}
				}
			}
		}

		&__bg {
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: $colorBrandMain;
			z-index: -1;
			transform-origin: 100% 100%;
			transform: skew(0, -.7deg);
			transition: 1s transform $easeOutQuint, .5s opacity;

			@include mq($to: medium) {
				.visible &::after {
					transform: skew(0, -3deg) translateY(15px);
				}
			}

			&::after {
				content: "";
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba($colorBrandMain, .4);
				z-index: -1;
				transform-origin: 100% 100%;
				transform: skew(0, -.4deg);
				transition: .5s opacity, 2s transform $easeOutQuint;
			}
		}

		.page-home-de &, .page-home-en & {
			background: transparent;
			position: absolute;

			.c-main-nav__bg {
				// opacity: 0;
				transform: translateY(-120%) !important;

				&::after {
					// opacity: 0;
				}
			}
		}

		&__list {
			margin-left: 3rem;

			&-item {
				display: inline-block;
				color: inherit;
				margin-right: 1rem;
				position: relative;

				@include mq($to: medium) {
					text-align: center;
					font-size: 1.2rem;
				}
			}

			@include mq($to: big) {
				margin-left: 5rem;
			}

			@include mq($to: medium) {
				margin-left: 0;
				padding-top: 4rem;
				display: block;
				height: 0;
				overflow: hidden;
				transition: 1s height $easeOutQuint;

				&-item {
					display: block;
					line-height: 2;
				}
				.visible & {
					height: 18rem;
				}
			}
		}

		&__lang {
			position: absolute;
			top: 0;
			right: 2rem;

			&-item {
				display: inline-block;
				position: relative;
				padding-left: 1rem;

				&.is-active {
					.c-main-nav__lang-link::after {
						transform-origin: 0 0;
						transform: scale(1, 1);
					}
				}
				.has-hover &:hover {
					.c-main-nav__lang-link::after {
						transform-origin: 0 0;
						transform: scale(1, 1);
					}
				}
			}
			&-link {
				color: inherit;
				background: none!important;
				border: none;
				padding: 0!important;
				font:  inherit;
				/*border is optional*/
				cursor: pointer;
				position: relative;

				&::after {
					content: "";
					display: block;
					width: 106%;
					height: 2px;
					background-color: #fff;
					position: absolute;
					bottom: -4px;
					left: -3%;
					transform: scale(0, 1);
					transform-origin: 100% 0;
					transition: .3s transform $easeOutQuint;
				}

				&:focus {
					outline: 0;

					&::after {
						transform-origin: 0 0;
						transform: scale(1, 1);
					}
				}
				&:disabled {
					opacity: 0.5;
					cursor: not-allowed;
				}
			}

			@include mq($to: medium) {
				position: relative;
				right: 0;
				height: 0;
				overflow: hidden;
				transition: .5s height $easeOutQuint;
				text-align: center;

				&-item {
					padding-left: 0;
				}
				.visible & {
					height: 3rem;
				}
				&-link {
					margin-left: 0;
					margin-right: 1rem;
				}
			}
		}

		&__burger {
			cursor: pointer;
			position: absolute;
			right: 1rem;
			top: 1rem;
			color: #fff;
			font-size: 1rem;
			border: none;
			background: none;
			-webkit-appearance: none;
			width: 1.5rem;
			height: 1.5rem;

			&:focus, &:active {
				outline: none;
			}

			span {
				display: none;
			}
			&::after {
				content: "";
				display: block;
				width: 100%;
				height: 2px;
				background-color: #fff;
				position: absolute;
				top: 50%;
				left: 0;
				box-shadow: 0 7px 0 0 #fff, 0 -7px 0 0 #fff;
			}

			@include mq($from: medium) {
				display: none;
			}
		}
	}

	.page-home-de .c-main-nav.visible, .page-home-en .c-main-nav.visible {
		background-color: $colorBrandMain;

		.c-main-nav__bg {
			opacity: 1;

			&::after {
				opacity: 1;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// MainNav.vue?5ba59f8c